module.exports = __webpack_public_path__ + "static/media/2024_32.fff86723.jpg";